@import "config";

$logo-reduced-width: 40px;

@mixin openMenu {
	width: max-content;
	min-width: $main-nav-opened-width;

	[class*="icon-container"] {
		margin-right: $spacing-inline-nano;
	}

	.logoContainer {
		margin-bottom: $spacing-inline-xxxs;

		.logoMinified {
			display: none;
		}
	}

	.tag {
		[class*="icon-container"] {
			&:after {
				display: none;
			}
		}
	}
}

@mixin closeMenu {
	.menuItem {
		> * {
			width: 40px;

			// menuItem > Link (using * due it can be another element) > not(".icon-container")
			> * {
				&:not([class*="icon-container"]) {
					display: none;
				}
			}
		}
	}

	.logoContainer {
		margin-left: calc(50% - ($logo-reduced-width / 2));

		.logoMinified {
			svg {
				height: 40px;
			}
		}

		.logoExpanded {
			display: none;
		}
	}
}

.navContainer {
	min-width: $main-nav-collpased-width;
	width: $main-nav-collpased-width;
	box-sizing: border-box;
	transition: all ease-in 0.1s;
	height: 100vh;
	z-index: 500;
	position: relative;
	background-color: $color-primary-pure;

	.navMenu {
		@include customScroll;
		margin: 0;
		list-style-type: none;
		height: calc(100% - 92px);
		padding: 0 $spacing-inset-xs $spacing-inset-xs;
	}

	.menuItem {
		min-height: 40px;
		font-size: $font-size-xxs;
		font-weight: $font-weight-bold;

		> * {
			@include flex(row, flex-start, center);
			width: 100%;
			border-radius: 50px;
			padding: $spacing-inset-nano;
			background-color: transparent;
			transition: background-color 0.3s;
		}

		* {
			color: $color-light-l5;
			text-decoration: none;
		}

		[class*="icon-container"] {
			@include flex(row, center, center);
			width: 24px;
			height: 24px;

			> svg {
				width: 24px;
				height: 24px;
				max-width: 24px;
				max-height: 24px;

				path,
				rect,
				circle,
				ellipse,
				line,
				polyline,
				polygon {
					&[stroke],
					&[stroke-width] {
						stroke: $color-light-l5;
					}

					&[fill] {
						fill: $color-light-l5;
					}
				}
			}
		}

		&.active > * {
			background-color: $color-highlight-pure;

			* {
				color: $color-primary-pure;
			}

			[class*="icon-container"] {
				> svg {
					path,
					rect,
					circle,
					ellipse,
					line,
					polyline,
					polygon {
						&[stroke],
						&[stroke-width] {
							stroke: $color-primary-pure;
						}

						&[fill] {
							fill: $color-primary-pure;
						}
					}
				}
			}
		}

		&:hover:not(.active) {
			> * {
				background-color: $color-primary-dark;
			}
		}
	}

	@include for-phone-only {
		position: absolute;
		left: -$main-nav-opened-width;
		top: 0;

		&.forceOpen {
			left: 0;
			@include openMenu;
		}

		&:not(.forceOpen) {
			@include closeMenu;
		}
	}

	@include for-grather-than-phone {
		&:hover {
			@include openMenu;
		}

		&:not(:hover) {
			@include closeMenu;
		}
	}

	.divider {
		margin: $spacing-stack-nano 0;
	}

	.logoContainer {
		max-width: 70px;
		margin: $spacing-inline-xxs auto;

		svg {
			height: 48px;
		}
	}

	@media print {
		display: none;
	}
}

.tag {
	[class*="icon-container"] {
		position: relative;

		&:after {
			top: -3px;
			right: -3px;
			content: "";
			width: 12px;
			height: 12px;
			position: absolute;
			border-radius: 100%;
		}
	}
}

.menuTag {
	font-size: 12px;
	display: inline-flex;
	margin-left: $spacing-inline-nano;
	color: $color-highlight-darkest !important;
	padding: 2px $spacing-inline-nano;
	align-items: flex-start;
	border-radius: 43px;

	&.comingSoon {
		color: $color-secondary-darkest;
		background-color: $color-secondary-lightest;
	}

	&.pending {
		color: $color-warning-darkest;
		background-color: $color-warning-medium;
	}

	&.new {
		color: $color-success-darkest;
		background-color: $color-success-medium;
	}
}

.menuItem {
	&.comingSoon {
		@extend .tag;

		[class*="icon-container"] {
			&:after {
				background-color: $color-secondary-lightest;
			}
		}
	}

	&.pending {
		@extend .tag;

		[class*="icon-container"] {
			&:after {
				background-color: $color-warning-medium;
			}
		}
	}

	&.new {
		@extend .tag;

		[class*="icon-container"] {
			&:after {
				background-color: $color-success-medium;
			}
		}
	}
}

.divider {
	width: 100%;
	height: 1px;
	background-color: $color-light-l1;
}

.patternContainer {
	left: 0;
	bottom: 0;
	width: 100%;
	z-index: -1;
	position: absolute;
	overflow: hidden;
	transition: width ease-in 0.1s;

	.pattern {
		top: 6px;
		position: relative;

		[class*="svg-group"] {
			mix-blend-mode: multiply;
			fill: $color-primary-pure;
		}
	}

	&:after {
		left: 0;
		bottom: 0;
		width: 100%;
		content: "";
		height: 256px;
		display: block;
		position: absolute;
		background: linear-gradient(180deg, $color-primary-pure 0%, rgba(0, 0, 0, 0) 100%);
	}
}
